module.exports = __webpack_public_path__ + "1791188489487/fonts/Flaticon.e905df2.woff";